// extracted by mini-css-extract-plugin
export default {"layout":"layout___jP_Sv","header":"header___WImle","slowItem":"slowItem___tYE7o","icon":"icon___uW2Qw","correct":"correct___nS9c6","itemLink":"itemLink___kPfWn"};